import { fmtCost } from "@/shared/lib/runs";

/** A model call costs fractions of a cent: below a tenth of one, four places, so it never reads $0.000. */
export const money = (usd: number): string => (usd > 0 && usd < 0.001 ? `$${usd.toFixed(4)}` : fmtCost(usd));

/** To the millionth of a dollar, for the places that give the exact figure. */
export const exactUsd = (usd: number): string => `$${usd.toFixed(6)}`;
